/**
 * CPT service facet flag descriptors: value extraction and canonical order.
 * Returns { kind, ...values } per flag; callers own intl formatting (leaf keys under filterDetail).
 */

export const CPT_FLAG_ORDER = ['duration', 'rate', 'callToBook', 'requireCreditCardForNewClients'];

export function isFreeCptRate(rate) {
  if (rate === null || rate === undefined) {
    return false;
  }
  if (typeof rate === 'number') {
    return rate === 0;
  }
  let s = String(rate).trim().toLowerCase();
  if (s === '' || s === 'free') {
    return true;
  }
  let n = parseFloat(s);
  return !Number.isNaN(n) && n === 0;
}

export function normalizedDuration(duration) {
  if (duration === null || duration === undefined || String(duration).trim() === '') {
    return null;
  }
  let n = Number(duration);
  return Number.isNaN(n) ? null : n;
}

function descriptorForKey(key, attrs) {
  switch (key) {
    case 'duration': {
      let minutes = normalizedDuration(attrs.duration);
      return minutes === null ? null : { kind: 'duration', minutes };
    }
    case 'rate': {
      if (isFreeCptRate(attrs.rate)) {
        return null;
      }
      let rate = String(attrs.rate ?? '').trim();
      return rate === '' ? null : { kind: 'rate', rate };
    }
    case 'callToBook':
      return {
        kind: 'callToBook',
        yes: attrs.callToBook === true || String(attrs.callToBook).toLowerCase() === 'true',
      };
    case 'requireCreditCardForNewClients':
      return {
        kind: 'requireCreditCardForNewClients',
        state: String(attrs.requireCreditCardForNewClients ?? '').trim() || '-',
      };
    default:
      return null;
  }
}

export function cptFlagDescriptors(attrs, flaggedKeys, { skipKeys = new Set() } = {}) {
  let wanted = new Set((flaggedKeys ?? []).map(String));
  let out = [];

  for (let key of CPT_FLAG_ORDER) {
    if (!wanted.has(key) || skipKeys.has(key)) {
      continue;
    }
    let descriptor = descriptorForKey(key, attrs);
    if (descriptor) {
      out.push(descriptor);
    }
  }

  return out;
}
